import React, { Component } from 'react';
import { MediaStatusTypes } from '../../Constants';
import IntroStyles from './Intro.cssmodule.less';
import Media from '../CommonSet/Media';
import classNames from 'classnames';

class CurriculumIntro extends Component {
    createMediaView(media = {}) {
        let view = null;
        const { category } = media;
        if (category && category !== MediaStatusTypes.NONE) {
            view = (
                <Media
                    className={classNames(category, IntroStyles.media)}
                    media={media}
                    params={{ type: 'course' }}
                    option={{ width: 640, height: 360 }}
                />
            );
        }
        return view;
    }

    render() {
        const textContents = this.props.data.textContent.split('\n');
        return (
            <div className={IntroStyles.curriculum}>
                {/* 스텝박스 영역 - 학습시작 / 학습목표에는 내용기술 안함. */}
                <div className={IntroStyles.intro_top}>
                    <div className={IntroStyles.intro_inner}>
                        {/* 느낌표 일때 exclamation 클래스 / 물음표 일때 question 클래스 */}
                        <div className={classNames(IntroStyles.cell, IntroStyles.exclamation)}>
                            <div className={IntroStyles.thmb_group}>
                                <span className={IntroStyles.thmb}>&nbsp;</span>
                                <strong className={IntroStyles.title}>학습시작</strong>
                            </div>
                            {textContents.map((text, idx) => <span key={idx}>{text}<br/></span>)}
                        </div>
                    </div>
                </div>
                <div className={IntroStyles.body}>
                    {this.createMediaView(this.props.data.media)}
                </div>
            </div>
        );
    }
}

export default CurriculumIntro;



// WEBPACK FOOTER //
// ./components/Curriculum/Intro.js